var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckpointQuantum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0287 23C9.25968 23.0072 7.00212 18.0882 6.98629 12.0131C6.97047 5.93793 9.20238 1.00722 11.9714 1.00001C14.7404 0.992795 16.998 5.91181 17.0138 11.9869C17.0296 18.0621 14.7977 22.9928 12.0287 23Z",
    fill: "#FF6700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39803 17.5575C0.830084 14.8607 3.85798 10.1751 9.16103 7.09184C14.4641 4.00862 20.0341 3.69537 21.6021 6.39219C23.17 9.08901 20.1421 13.7747 14.8391 16.8579C9.53601 19.9411 3.96597 20.2544 2.39803 17.5575Z",
    fill: "#FF6700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21677 13.1248C3.07559 14.8907 3.00585 16.2013 3.4416 16.9508C3.87734 17.7003 5.05082 18.2881 7.1501 18.17C9.17489 18.0561 11.7102 17.2807 14.2323 15.8143C16.7545 14.3479 18.6826 12.5283 19.7833 10.825C20.9245 9.059 20.9943 7.7484 20.5585 6.99893C20.1228 6.24945 18.9493 5.66167 16.85 5.77973C14.8252 5.89359 12.2899 6.66901 9.76777 8.13541C7.2456 9.60181 5.31745 11.4215 4.21677 13.1248ZM9.16103 7.09184C3.85798 10.1751 0.830084 14.8607 2.39803 17.5575C3.96597 20.2544 9.53601 19.9411 14.8391 16.8579C20.1421 13.7747 23.17 9.08901 21.6021 6.39219C20.0341 3.69537 14.4641 4.00862 9.16103 7.09184Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.631 17.5075C20.2517 19.9086 14.8216 19.378 9.50261 16.3225C4.18357 13.2669 0.989777 8.84345 2.36908 6.44239C3.74838 4.04134 9.17846 4.57192 14.4975 7.62747C19.8165 10.683 23.0103 15.1065 21.631 17.5075Z",
    fill: "#FF6700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckpointQuantum);
export default __webpack_public_path__ + "static/media/CheckpointQuantum.6cdcb11d694f764bbaba9a2f198d2b5c.svg";
export { ForwardRef as ReactComponent };